import router from '@/router'

const redirectTo = (url) => {
  // console.log('redirectTo - url', url)
  router.push({ path: url })
}

export default redirectTo
